import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/layouts/Main';
import AddGroupModal from '../../components/groups/AddGroupModal';
import { Button, Row, Col, Badge } from 'react-bootstrap';
import config from '../../config';
import { PulseLoader } from "react-spinners";

function GroupsList() {
  const [groups, setGroups] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchGroups = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${config.API_BASE_URL}/groups`);
      setGroups(res.data);
    } catch (err) {
      console.error('Failed to fetch groups', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGroupAdded = () => {
    setShowAddModal(false);
    fetchGroups();
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  return (
    <Layout>
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
          <li className="breadcrumb-item active">Groups</li>
        </ol>
      </nav>
      
      <Row className="mb-3">
        <Col><h2>Groups <span className="text-muted">({groups.length})</span></h2></Col>
        <Col className="text-end">
          <Button onClick={() => setShowAddModal(true)}>+ Add Group</Button>
        </Col>
      </Row>

      {isLoading ? (
        <PulseLoader color="#014b7cbb" size={9} />
      ) : (
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Group Name</th>
                <th>Group Code</th>
                <th>Description</th>
                <th>Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {groups.map(group => (
                <tr key={group._id}>
                  <td>{group.groupName}</td>
                  <td>{group.groupCode}</td>
                  <td>{group.description || 'N/A'}</td>
                  <td>
                    <Badge bg={group.isActive ? 'success' : 'danger'}>
                      {group.isActive ? 'Active' : 'Inactive'}
                    </Badge>
                  </td>
                  <td>{new Date(group.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <AddGroupModal 
        show={showAddModal} 
        onHide={() => setShowAddModal(false)} 
        onGroupAdded={handleGroupAdded} 
      />
    </Layout>
  );
}

export default GroupsList;